import { HostFlatNode } from '.';
import { PrtgConstants, HostStatus } from '../prtg-constants';

export class HostsFilter
{
    public _statuses: HostStatus[];
    get statuses ()
    {
        return this._statuses;
    }
    set statuses (value)
    {
        this._statuses = value;
        this.flagStatus = this._statuses.reduce((acc: number, cur: number) =>
            acc | cur, 0
        );
    }
    public flagStatus: number;
    public types: string[] = [];

    constructor ()
    {
        this._statuses = [...PrtgConstants.HostDownFlagStatusArray];
        this.flagStatus = PrtgConstants.HostDownFlagStatus;
        this.types = [];
    }

    public static mapperFromObject (source: any): HostsFilter
    {
        const target = new HostsFilter();
        Object.assign(target, source);

        return target;
    }

    public applyFilter (flatNodes: HostFlatNode[]): HostFlatNode[]
    {
        return flatNodes.filter((flatNode: HostFlatNode) =>
            // tslint:disable-next-line: no-bitwise
            !this.flagStatus || (this.flagStatus & flatNode.flagStatus) !== 0
            &&
            (this.types.length === 0 || (this.types.includes(flatNode.typeHost)))
        );
    }
}
